import { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import {
  IonHeader,
  IonToolbar,
  IonContent,
  IonTitle,
  IonModal,
  IonButtons,
  IonButton,
  IonList,
  IonItem,
  IonLabel,
} from "@ionic/react";

// store
import { usePaymentsStore } from "../../store/payments";

const PaymentDetails = ({
  onWillDismiss,
  isOpen,
  selectedPayment,
}: {
  isOpen: boolean;
  onWillDismiss: () => void;
  selectedPayment: any;
}) => {
  const { getPayment } = usePaymentsStore();

  const payment = getPayment(selectedPayment?.id);

  console.log(payment);

  return payment ? (
    <>
      <IonModal isOpen={isOpen} onWillDismiss={onWillDismiss}>
        <IonHeader>
          <IonToolbar>
            <IonTitle>
              <FormattedMessage id={`nav.payments`} />
            </IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => onWillDismiss()}>
                <FormattedMessage id="common.close" />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonList inset={true}>
            <IonItem>
              <IonLabel>
                <div className="fs-2 color-step-750 fw-bold">
                  <FormattedMessage id="leads.payments.paymentRequested" />
                </div>
              </IonLabel>
            </IonItem>
            <IonItem>
              <IonLabel>
                <div className="fs-2 color-step-750">
                  <FormattedMessage id="leads.payments.amount" />
                </div>
              </IonLabel>
              <div slot="end" className="fs-2 color-step-750">
                {payment?.amount} {/*({payment?.percentage}) */}
              </div>
            </IonItem>
            <IonItem>
              <IonLabel>
                <div className="fs-2 color-step-750">Status</div>
              </IonLabel>
              <div slot="end" className="fs-2 color-step-750">
                {
                  <FormattedMessage
                    id={`leads.payments.${payment?.paymentStatus}`}
                  />
                }
              </div>
            </IonItem>
            {payment?.source === "item" && payment?.itemName && (
              <IonItem>
                <IonLabel>
                  <div className="fs-2 color-step-750">
                    <FormattedMessage id="leads.payments.reference" />
                  </div>
                </IonLabel>
                <div slot="end" className="fs-2 color-step-750">
                  {(payment?.itemQuantity || 1) + " x " + payment.itemName}
                </div>
              </IonItem>
            )}

            {payment?.paymentStatus === "paid" && false && (
              <IonItem>
                <div slot="end">
                  <button className="btn btn-visito-light btn-sm">
                    <FormattedMessage id="leads.payments.makeArefund" />
                  </button>
                </div>
              </IonItem>
            )}
          </IonList>

          {payment?.convertedAmount && (
            <IonList inset={true}>
              <IonItem>
                <IonLabel>
                  <div className="fs-2 color-step-750 fw-bold">
                    <FormattedMessage id="leads.payments.paymentBreakDown" />
                  </div>
                </IonLabel>
              </IonItem>
              <IonItem>
                <IonLabel>
                  <div className="fs-2 color-step-750">
                    <FormattedMessage id="leads.payments.amount" />
                  </div>
                </IonLabel>
                <div slot="end" className="fs-2 color-step-750">
                  {payment?.amount} {"->"} {payment?.convertedAmount}
                </div>
              </IonItem>
              <IonItem>
                <IonLabel>
                  <div className="fs-2 color-step-750">
                    <FormattedMessage id="leads.payments.fees" />
                  </div>
                </IonLabel>
                <div slot="end" className="fs-2 color-step-750">
                  {payment?.stripeFee}
                </div>
              </IonItem>
              {/*
              <IonItem>
                <IonLabel>
                  <div className="fs-2 color-step-950">
                    <FormattedMessage id="leads.payments.netAmount" />
                  </div>
                </IonLabel>
                <div slot="end" className="fs-2 color-step-950">
                  {payment?.netAmount}
                </div>
              </IonItem>
              */}
              <IonItem>
                <IonLabel>
                  <div className="fs-2 color-step-750">
                    <FormattedMessage id="leads.payments.commission" />
                  </div>
                </IonLabel>
                <div slot="end" className="fs-2 color-step-750">
                  {payment?.platformCommission}{" "}
                </div>
              </IonItem>
              <IonItem>
                <IonLabel>
                  <div className="fs-2 color-step-950">
                    <FormattedMessage id="leads.payments.providerNetAmount" />
                  </div>
                </IonLabel>
                <div slot="end" className="fs-2 color-step-950">
                  {payment?.providerNet}
                </div>
              </IonItem>
            </IonList>
          )}
          {payment?.refunds && payment?.refunds.length > 0 && (
            <IonList inset={true}>
              <IonItem>
                <IonLabel>
                  <div className="fs-2 color-step-750 fw-bold">
                    <FormattedMessage id="leads.payments.refunds" />
                  </div>
                </IonLabel>
              </IonItem>
              {payment?.refunds.map((refund: any, index: number) => (
                <IonItem key={index}>
                  <IonLabel>
                    <div className="fs-2 color-step-750">
                      {refund.date} - {refund.status}
                    </div>
                  </IonLabel>
                  <div slot="end" className="fs-2 color-step-950">
                    {refund.amount}
                  </div>
                </IonItem>
              ))}
            </IonList>
          )}
          {payment?.bookings && payment?.bookings.length > 0 && (
            <IonList inset={true}>
              <IonItem>
                <IonLabel>
                  <div className="fs-2 color-step-750 fw-bold">
                    <FormattedMessage id="leads.payments.bookings" />
                  </div>
                </IonLabel>
              </IonItem>
              {payment?.bookings.map((booking: any) => (
                <IonItem key={booking.id}>
                  <IonLabel>
                    <div className="fs-2 color-step-750">
                      ID: {booking.externalId}
                    </div>
                  </IonLabel>
                  <div slot="end" className="fs-2 color-step-950">
                    {booking.amountPaid} / {booking.grandTotal}
                  </div>
                </IonItem>
              ))}
            </IonList>
          )}
          {payment?.source === "item" &&
            payment?.itemPropertyValues &&
            payment?.itemPropertyValues.length > 0 && (
              <IonList inset={true}>
                <IonItem>
                  <IonLabel>
                    <div className="fs-2 color-step-750 fw-bold">
                      <FormattedMessage id="leads.payments.itemProperties" />
                    </div>
                  </IonLabel>
                </IonItem>
                {payment.itemPropertyValues.map((property: any) => (
                  <IonItem key={property.fieldId}>
                    <IonLabel>
                      <div className="fs-2 color-step-750">{property.label}</div>
                    </IonLabel>
                    <div slot="end" className="fs-2 color-step-950">
                      {String(property.value)}
                    </div>
                  </IonItem>
                ))}
              </IonList>
            )}
        </IonContent>
      </IonModal>
    </>
  ) : null;
};
export default PaymentDetails;
